module.exports = __webpack_public_path__ + "images/Monti_2510-4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/babel/Monti_2510-4.jpg
// module id = 53
// module chunks = 0